import { destroy, get, post, put } from '.';

export function GetAppointmentSchedulingHours(options = {}) {
	return get<any>("/app/api/appointment_scheduling_hours", options);
}

export function DestroyAppointmentSchedulingHour(id, options = {}) {
	return destroy<any>("/app/api/appointment_scheduling_hours/" + (id || 0).toString(), options);
}

export function CreateAppointmentSchedulingHour(options = {}) {
	return post<any>("/app/api/appointment_scheduling_hours", options);
}

export function UpdateAppointmentSchedulingHour(id, options = {}) {
	return put<any>("/app/api/appointment_scheduling_hours/" + (id || 0).toString(), options);
}